import { Layout } from "../components/Layout";
import { Panel } from "../components/Panel";
import { canEditWorkspace, getWorkspaceAccessMessage } from "../lib/adminActions";
import { startDepartment, statusLabel } from "../lib/departmentWorkflow";
import { useWorkspaceLanguage } from "../lib/i18n";
import { getWorkspaceState, saveWorkspaceState } from "../lib/workspaceStore";

interface InviteProps {
  inviteToken: string;
}

export function Invite({ inviteToken }: InviteProps) {
  const language = useWorkspaceLanguage();
  const copy = language === "en" ? {
    eyebrow: "Invite",
    notFoundTitle: "Invite not found",
    notFoundDescription: "The link could not be assigned to an active department.",
    checkLink: "Please check the link",
    checkLinkBody: "If you were invited, please open the complete invite link from your invitation.",
    description: (workspaceName: string) => `${workspaceName}: You start the workshop exclusively from your department's perspective.`,
    startTitle: "Start department perspective",
    trust: "The workspace does not evaluate people. It makes department perspectives visible.",
    status: "Status",
    startWorkshop: "Start workshop"
  } : {
    eyebrow: "Invite",
    notFoundTitle: "Invite nicht gefunden",
    notFoundDescription: "Der Link konnte keiner aktiven Abteilung zugeordnet werden.",
    checkLink: "Bitte prüfen Sie den Link",
    checkLinkBody: "Wenn Sie eingeladen wurden, öffnen Sie bitte den vollständigen Invite-Link aus Ihrer Einladung.",
    description: (workspaceName: string) => `${workspaceName}: Sie starten den Workshop ausschließlich aus Sicht Ihrer Abteilung.`,
    startTitle: "Abteilungsperspektive starten",
    trust: "Der Workspace bewertet keine Personen. Er macht Abteilungsperspektiven sichtbar.",
    status: "Status",
    startWorkshop: "Workshop starten"
  };
  const state = getWorkspaceState();
  const department = state.departments.find((item) => item.inviteToken === inviteToken);
  const workspace = department ? state.workspaces.find((item) => item.id === department.workspaceId) : undefined;
  const accessMessage = workspace ? getWorkspaceAccessMessage(workspace.status, language) : undefined;
  const startedDepartment = department ? startDepartment(department) : undefined;
  if (department && department.status === "invited") {
    department.status = "started";
    saveWorkspaceState(state);
  }

  if (!department || !workspace || !startedDepartment) {
    return (
      <Layout
        eyebrow={copy.eyebrow}
        title={copy.notFoundTitle}
        description={copy.notFoundDescription}
      >
        <Panel title={copy.checkLink} variant="accent">
          <p>{copy.checkLinkBody}</p>
        </Panel>
      </Layout>
    );
  }

  return (
    <Layout
      eyebrow={copy.eyebrow}
      title={startedDepartment.name}
      description={copy.description(workspace.name)}
    >
      <Panel title={copy.startTitle} variant="accent">
        <p>{copy.trust}</p>
        <p className="muted">{copy.status}: {statusLabel(startedDepartment.status, language)}</p>
        {accessMessage ? <p>{accessMessage}</p> : null}
        {workspace && canEditWorkspace(workspace.status) ? (
          <a className="button button-primary" href={`/contributor/${startedDepartment.id}`}>
            {copy.startWorkshop}
          </a>
        ) : null}
      </Panel>
    </Layout>
  );
}
